import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialog: {
    width: '500px'
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  multFieldLine: {
    display: 'flex',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1)
    }
  },

  btnWrapper: {
    position: 'relative'
  },

  buttonProgress: {
    color: theme.palette.green_200.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  inputAutocomplete: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '& .MuiInputBase-root': {
      padding: '2px 8px !important'
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& span': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      fontSize: '.875rem',
      fontFamily: 'Inter, sans-serif',
      fontWeight: '400',
      lineWeight: '1'
    }
  },
  inputHour: {
    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px'
    },
    '& svg': {
      color: theme.palette.gray_400.main
    },
    '& input': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      padding: '12px'
    }
  }
}))
